<template>
    <div>
      <Tables ref="tableUsersGrid"
                style="font-family:'Segoe UI'"
                :columns="headTable"
                :showSearch="false"
                :showPrint="false"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
              >
                <tr v-for="user in usersArray" :key="user.id">
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',user)" :status="1" :value="user.nome" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',user)" :status="1" :value="user.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',user)" :status="1" :value="user.rg" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',user)" :status="1" :value="user.creci" />
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',user)" :status="1" :value="user.ufCreci.sigla" />
                    <TableColumn :newState="true" v-on:Edit="$emit('selectUser',user)" :newStatusNumber="user.aprovado == true ? 1 : 2" :descriptionNewStatus="['Ag. Aprovação','Aprovado'][user.aprovado == true ?  1 : 0]"  :status="1" :value="user.aprovado == true ? 1 : 0"/>
                    <TableColumn :IsText="true"   v-on:Edit="$emit('selectUser',user)"  :status="1" :value="user.dataAcaoFormatada" />
                    <TableColumn :IsActionsButtons="true" v-on:Change="$emit('inactivateUser', user)" v-on:Delete="$emit('deleteUser', user)" :status="user.aprovado == true ? 0 : 1"  />
                </tr>
              </Tables>
    </div>
</template>
<script>
import RealtorTable from '@/views/private/realestate/users/components/RealtorTable/RealtorTable.js'
export default RealtorTable

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/components/RealtorTable/RealtorTable.vue